import { render, staticRenderFns } from "./RenewMemberModal.vue?vue&type=template&id=56aa8f64&scoped=true&"
import script from "./RenewMemberModal.vue?vue&type=script&lang=js&"
export * from "./RenewMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./RenewMemberModal.vue?vue&type=style&index=0&id=56aa8f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aa8f64",
  null
  
)

export default component.exports